<template>
<div>
    <b-navbar-item style="color:#3e8ed0;" tag="router-link" :to="{ name: 'Clusters' }">
                  Clusters
              </b-navbar-item>
              <b-navbar-item style="color:#3e8ed0" tag="router-link" :to="{ name: 'Playlists' }">
                  Playlists
              </b-navbar-item>
              <b-navbar-item style="color:#3e8ed0" tag="router-link" :to="{ name: 'Devices' }">
                  Devices
              </b-navbar-item>
              <b-navbar-item v-if="addOns.powerDevices" style="color:#3e8ed0" tag="router-link" :to="{ name: 'PowerDevices' }">
                  Power devices
              </b-navbar-item>
              <b-navbar-item style="color:#3e8ed0" tag="router-link" :to="{ name: 'Menus' }">
                  Menus
              </b-navbar-item>
              <b-navbar-item style="color:#3e8ed0" tag="router-link" :to="{ name: 'SpecialOffers' }">
                  Special Offers
              </b-navbar-item>
              <b-navbar-item v-if="addOns.documents" style="color:#3e8ed0" tag="router-link" :to="{ name: 'Documents' }">
                  Documents
              </b-navbar-item>
              <b-navbar-item v-if="addOns.appMenu" style="color:#3e8ed0" tag="router-link" :to="{ name: 'AppMenu' }">
                App Menu/Tiles
              </b-navbar-item>
              <b-navbar-item v-if="addOns.appMenu" style="color:#3e8ed0" tag="router-link" :to="{ name: 'AppMenuPdfs}' }">
                App Menu/PDFs
              </b-navbar-item>
              <b-navbar-item v-if="addOns.questionnaires" style="color:#3e8ed0" tag="router-link" :to="{ name: 'Questionnaires' }">
                Questionnaires
              </b-navbar-item>
              <b-navbar-item v-if="addOns.questionnaires" style="color:#3e8ed0" tag="router-link" :to="{ name: 'QuestionnaireAnalytics' }">
                Qtn Analytics
              </b-navbar-item>
              <b-navbar-item v-if="addOns.customerSatisfaction" style="color:#3e8ed0" tag="router-link" :to="{ name: 'CustomerSatisfaction' }">
                  Customer Satisfaction
              </b-navbar-item>
              <b-navbar-item style="color:#3e8ed0" tag="router-link" :to="{ name: 'Analytics' }">
                  Analytics
              </b-navbar-item>
              <b-navbar-item style="color:#3e8ed0" tag="router-link" :to="{ name: 'PlaylistsStorage' }">
                  Storage/Playlists
              </b-navbar-item>
              <b-navbar-item style="color:#3e8ed0" tag="router-link" :to="{ name: 'MenusStorage' }">
                  Storage/Menus
              </b-navbar-item>
              <b-navbar-item style="color:#3e8ed0" tag="router-link" :to="{ name: 'OffersStorage' }">
                  Storage/Special Offers
              </b-navbar-item>
              <b-navbar-item v-if="addOns.tickets" style="color:#3e8ed0" tag="router-link" :to="{ name: 'Tickets' }">
                  Tickets
              </b-navbar-item>
              </div>
</template>

<script>
// import * as firebase from 'firebase'

export default {
  name: 'MenuMobile',
  computed: {
    addOns () {
      return this.$store.state.addOns
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MenuMobile.vue